var exports = {
  "hl": "xf0b3b88a--9ff1a5--address",
  "vI": "xf0b3b88a--9ff1a5--header-link",
  "PH": "xf0b3b88a--9ff1a5--building",
  "k1": "xf0b3b88a--9ff1a5--building-link",
  "fZ": "xf0b3b88a--9ff1a5--reliable-wrapper",
  "Bh": "xf0b3b88a--9ff1a5--external-reliable-icon",
  "NL": "xf0b3b88a--9ff1a5--reliable-icon",
  "lY": "xf0b3b88a--9ff1a5--popup",
  "Kk": "xf0b3b88a--9ff1a5--icon",
  "DD": "xf0b3b88a--9ff1a5--title",
  "nf": "xf0b3b88a--9ff1a5--link",
  "dC": "xf0b3b88a--9ff1a5--region-metro",
  "zJ": "xf0b3b88a--9ff1a5--address-path",
};

module.exports = exports;
